import { render } from "./AboutMe.vue?vue&type=template&id=842dd20c&scoped=true&ts=true"
import script from "./AboutMe.vue?vue&type=script&lang=ts"
export * from "./AboutMe.vue?vue&type=script&lang=ts"

import "./AboutMe.vue?vue&type=style&index=0&id=842dd20c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-842dd20c"]])

export default __exports__